import ModelBaseClass from "@quasidea/oas-client-react/lib/ModelBaseClass";
import VaultSetUsersRequest from "../VaultSetUsersRequest";
import ModelProxyClass from "./ModelProxyClass";


/**
 * @class VaultSetUsersRequestBase
 * @extends ModelBaseClass
 * @property {number} cashAccountId (int64) ID of the Vault CashAccount to set/update the list of accessible users to
 * @property {[number]} personIds
 */
class VaultSetUsersRequestBase extends ModelBaseClass {
	/**
	 * ID of the Vault CashAccount to set/update the list of accessible users to
	 * @type {number} cashAccountId (int64)
	 */
	cashAccountId;
	/**
	 * @type {[number]} personIds
	 */
	personIds;

	/**
	 * Instantiates a new instance of VaultSetUsersRequest based on the generic object being passed in (typically from a JSON object)
	 * @param {object} genericObject
	 * @return {VaultSetUsersRequest}
	 */
	static create(genericObject) {
		const newVaultSetUsersRequest = new VaultSetUsersRequest();
		newVaultSetUsersRequest.instantiate(_modelDefinition, genericObject, ModelProxyClass.createByClassName);
		return newVaultSetUsersRequest;
	}

	/**
	 * Instantiates a new array of VaultSetUsersRequest based on the generic array being passed in (typically from a JSON array)
	 * @param {[object]} genericArray
	 * @return {[VaultSetUsersRequest]}
	 */
	static createArray(genericArray) {
		if (genericArray === null) {
			return null;
		}

		const newVaultSetUsersRequestArray = [];
		genericArray.forEach(genericObject => {
			newVaultSetUsersRequestArray.push(VaultSetUsersRequest.create(genericObject));
		});
		return newVaultSetUsersRequestArray;
	}
}

const _modelDefinition = [
	ModelBaseClass.createModelProperty('cashAccountId', 'integer'),
	ModelBaseClass.createModelProperty('personIds', '[integer]'),
];

export default VaultSetUsersRequestBase;
